import api from '@/api/folders';
import store from '@/store/store';

const fetchFolder = (context, id) => new Promise(((resolve, reject) => {
  api.fetchFolder(id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const updateFolder = (context, params) => new Promise(((resolve, reject) => {
  api.updateFolder(params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const createFolder = (context, params) => new Promise(((resolve, reject) => {
  api.createFolder(params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const deleteFolder = (context, id) => new Promise(((resolve, reject) => {
  api.deleteFolder(id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const fetchFolderTree = (context, forStatement) => new Promise(((resolve, reject) => {
  api.fetchFolderTree()
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchFolderTreeChild = (context, id) => new Promise(((resolve, reject) => {
  api.fetchFolderTreeChild(id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const searchInFolder = (context, term) => new Promise(((resolve, reject) => {
  api.searchInFolder(term)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

export default {
  fetchFolder,
  updateFolder,
  createFolder,
  deleteFolder,
  fetchFolderTree,
  fetchFolderTreeChild,
  searchInFolder,
};




// WEBPACK FOOTER //
// ./src/store/modules/folders/actions.js